module.exports = __webpack_public_path__ + "static/media/krx-trading-investor-01.f6eae445.jpg";